<template>
    <div class="incident-history-accordion">
        <div v-if="approvals && approvals.length > 0">
            <b-card v-for="(approval, index) in approvals" :key="index" no-body class="mb-1">
                <b-card-header header-tag="header" role="tab" class="p-1 cursor-pointer" v-b-toggle="`approval-collapse-${index}`">
                    <div class="d-flex justify-content-between align-items-center w-100">
                        <div class="flex-grow-1">
                            <div class="row">
                                <div class="col-3">
                                    <small class="text-muted d-block text-nowrap">Tarih & Onaycı</small>
                                    <p class="font-weight-bold mb-0 text-nowrap text-truncate" :title="`${approval.ActionDateStr || 'N/A'} - ${approval.ApproverUserFullName || 'N/A'}`">
                                        {{ approval.ActionDateStr || "N/A" }} - {{ approval.ApproverUserFullName || "N/A" }}
                                    </p>
                                </div>
                                <div class="col-2">
                                    <small class="text-muted d-block text-nowrap">Onay Tipi</small>
                                    <p class="font-weight-bold mb-0 text-nowrap text-truncate" :title="approval.ApprovalTypeName || '-'">
                                        {{ approval.ApprovalTypeName || "-" }}
                                    </p>
                                </div>
                                <div class="col-2">
                                    <small class="text-muted d-block text-nowrap">Durum</small>
                                    <b-badge :variant="approvalStatusVariant(approval.ApprovalStatus)">
                                        {{ approval.ApprovalStatusName || "-" }}
                                    </b-badge>
                                </div>
                                <div class="col-2">
                                    <small class="text-muted d-block text-nowrap">Uygulandı</small>
                                    <p class="font-weight-bold mb-0 text-nowrap">
                                        {{ approval.Applied ? "EVET" : "HAYIR" }}
                                    </p>
                                </div>
                                <div class="col-2">
                                    <small class="text-muted d-block text-nowrap">Açıklama</small>
                                    <p class="font-weight-bold mb-0 text-nowrap text-truncate" :title="approval.Description || '-'">
                                        {{ approval.Description || "-" }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="ml-1"><feather-icon icon="ChevronDownIcon" size="20" class="text-muted" /></div>
                    </div>
                </b-card-header>

                <b-collapse :id="`approval-collapse-${index}`" accordion="incident-history-accordion" role="tabpanel">
                    <b-card-body class="p-1 border-top">
                        <div class="mb-1">
                            <small class="text-muted d-block text-nowrap">Değişiklik Açıklaması</small>
                            <p class="mb-0">{{ approval.ChangeDescription || "-" }}</p>
                        </div>

                        <table v-if="hasFieldChanges(approval)" class="table table-bordered table-sm mb-0 mt-0">
                            <thead class="thead-light">
                                <tr>
                                    <th>Değişen Alan</th>
                                    <th>Eski Değer</th>
                                    <th>Yeni Değer</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="approval.CompanyAmountChanged">
                                    <td>Firma Tutarı</td>
                                    <td>{{ formatMoney(approval.OldCompanyAmount) }}</td>
                                    <td>{{ formatMoney(approval.NewCompanyAmount) }}</td>
                                </tr>
                                <tr v-if="approval.EmployeeAmountChanged">
                                    <td>Sürücü Tutarı</td>
                                    <td>{{ formatMoney(approval.OldEmployeeAmount) }}</td>
                                    <td>{{ formatMoney(approval.NewEmployeeAmount) }}</td>
                                </tr>
                                <tr v-if="approval.EmployeeDepositAmountChanged">
                                    <td>Sürücü Emanet Tutarı</td>
                                    <td>{{ formatMoney(approval.OldEmployeeDepositAmount) }}</td>
                                    <td>{{ formatMoney(approval.NewEmployeeDepositAmount) }}</td>
                                </tr>
                                <tr v-if="approval.InstallmentCountChanged">
                                    <td>Taksit Sayısı</td>
                                    <td>{{ approval.OldInstallmentCount }}</td>
                                    <td>{{ approval.NewInstallmentCount }}</td>
                                </tr>
                                <tr v-if="approval.StatusChanged">
                                    <td>Durum</td>
                                    <td>{{ incidentStatusText(approval.OldStatus) }}</td>
                                    <td>{{ incidentStatusText(approval.NewStatus) }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div v-else class="text-center p-0 text-muted">Bu onay için alan değişikliği bulunmuyor.</div>
                    </b-card-body>
                </b-collapse>
            </b-card>
        </div>
        <div v-else>
            <p class="text-center">Bu vukuat için bir onay geçmişi bulunamadı.</p>
        </div>
    </div>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BCollapse, VBToggle, BBadge } from "bootstrap-vue";

export default {
    components: {
        BCard,
        BCardHeader,
        BCardBody,
        BCollapse,
        BBadge,
    },
    directives: {
        "b-toggle": VBToggle,
    },
    props: {
        approvals: {
            type: Array,
            required: true,
        },
    },
    methods: {
        approvalStatusVariant(status) {
            const map = {
                0: "light-warning",
                1: "light-success",
                2: "light-danger",
            };
            return map[status] || "light-secondary";
        },
        incidentStatusText(status) {
            const map = {
                0: "Ödeme Bekleniyor",
                1: "Diğer Ödemeler Bekleniyor",
                2: "Ödendi",
                3: "Pasif",
                4: "Onay Sürecinde",
            };
            return map[status] || "-";
        },
        hasFieldChanges(approval) {
            return (
                !!approval.CompanyAmountChanged ||
                !!approval.EmployeeAmountChanged ||
                !!approval.EmployeeDepositAmountChanged ||
                !!approval.InstallmentCountChanged ||
                !!approval.StatusChanged
            );
        },
        formatMoney(value) {
            if (typeof value !== "number") return "-";
            return value.toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " ₺";
        },
    },
};
</script>



